import { render, staticRenderFns } from "./Offices.vue?vue&type=template&id=2b07bbde&scoped=true"
import script from "./Offices.vue?vue&type=script&lang=js"
export * from "./Offices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b07bbde",
  null
  
)

export default component.exports